import {ok} from 'framework';
import type {Result} from 'framework';
import type {KeyValueStoragePort} from '@/shared/application/ports/key-value-storage.port';
import type {KeepScreenAwakePreferenceRepository} from '../../application/ports/keep-screen-awake-preference.repository';
import type {KeepScreenAwakePreference} from '../../domain/keep-screen-awake-preference.value-object';

export const KEEP_SCREEN_AWAKE_PREFERENCE_STORAGE_KEY = 'workouts:keep-screen-awake:v1';

const KEEP_SCREEN_AWAKE_ON_VALUE = '1';

/**
 * Stores the Keep screen awake flag in a {@link KeyValueStoragePort}.
 * Read failures and unknown values fall back to off so a Screen Wake Lock
 * is never requested without an explicit opt-in.
 */
export class KeyValueKeepScreenAwakePreferenceRepository implements KeepScreenAwakePreferenceRepository {
  constructor(private readonly storage: KeyValueStoragePort) {}

  async get(): Promise<Result<KeepScreenAwakePreference>> {
    const result = await this.storage.get(KEEP_SCREEN_AWAKE_PREFERENCE_STORAGE_KEY);

    if (!result.ok) {
      return ok('off');
    }

    return ok(result.data === KEEP_SCREEN_AWAKE_ON_VALUE ? 'on' : 'off');
  }

  set(preference: KeepScreenAwakePreference): Promise<Result<void>> {
    if (preference === 'on') {
      return this.storage.set(KEEP_SCREEN_AWAKE_PREFERENCE_STORAGE_KEY, KEEP_SCREEN_AWAKE_ON_VALUE);
    }

    return this.storage.remove(KEEP_SCREEN_AWAKE_PREFERENCE_STORAGE_KEY);
  }
}
